import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_admin',
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel');
    },
    smartControlSel: function smartControlSel() {
      return import('../smartControl/smartControl_sel');
    },
    smartControlItemSel: function smartControlItemSel() {
      return import('../smartControl/smartControlItem_sel.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      roleDatas: [],
      pageConfig: {
        editPageName: '能耗设备',
        addFunName: 'monitorAdd',
        modifyFunName: 'monitorModify',
        queryFunName: 'monitorQuery',
        detailFunName: 'monitorDetail',
        delFunName: 'monitorDel'
      },
      searchForm: {
        deviceCategory: 'Energy'
        // labId: localStorage.getItem('labId')
      },
      formData: {
        deviceCategory: 'Energy',
        deviceType: 'Physical',
        meterType: 'Sub'
      },
      rules: {
        deviceName: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      formLabelWidth1: '140px',
      emptyFormData: {},
      labShow: false,
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false,
      smartControl_show: false,
      smartControlItem_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    upload: function upload(_ref) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this.formData.deviceImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.deviceImage);
    },
    removeFile: function removeFile() {
      this.formData.deviceImage = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(_ref3) {
      var _this2 = this;
      var id = _ref3.id,
        labName = _ref3.labName;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this2.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
          labName: labName
        }));
        _this2.editDialogTitle = _this2.pageConfig.editPageName + '维护';
        _this2.editDialogShow = true;
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, "onlineSmartControlId", null);
        this.$set(this.formData, "onlineSmartControlName", null);
        this.$set(this.formData, "powerSmartControlId", null);
        this.$set(this.formData, "powerSmartControlName", null);
        this.$set(this.formData, "activePower", null);
        this.$set(this.formData, "activeEnergy", null);
      }
      this.labShow = false;
    },
    smartControlClick: function smartControlClick(attr) {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业！');
        return;
      }
      this.attr = attr;
      this.smartControl_show = true;
    },
    smartControlSel: function smartControlSel(data) {
      if (data) {
        this.$set(this.formData, "".concat(this.attr, "Id"), data.id);
        this.$set(this.formData, "".concat(this.attr, "Name"), data.name);
        this.$set(this.formData, "activePower", null);
        this.$set(this.formData, "activeEnergy", null);
      }
      this.smartControl_show = false;
    },
    itemClick: function itemClick(code) {
      if (!this.formData.powerSmartControlId) {
        this.$message.info('请先选择电能设备！');
        return;
      }
      this.code = code;
      this.smartControlItem_show = true;
    },
    smartControlItemSel: function smartControlItemSel(data) {
      if (data) {
        this.$set(this.formData, this.code, data.typeCode);
      }
      this.smartControlItem_show = false;
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
      this.queryLoading = false;
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.id) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_objectSpread(_objectSpread({}, _this5.formData), {}, {
              account: _this5.formData.phone
            }))).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_objectSpread(_objectSpread({}, _this5.formData), {}, {
              account: _this5.formData.phone
            }))).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};